var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 124",
    style: {
      enableBackground: "new 0 0 136 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFFCFC;}\n\t.st1{opacity:0.7;fill:#EFFCFC;enable-background:new    ;}\n\t.st2{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_1385_3438_00000019656520188517027360000000848818477167143832_);}\n\t.st4{fill:#028383;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 37,
    y: 50.7,
    width: 69.9,
    height: 43.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 50.7,
    width: 69.9,
    height: 43.6,
    id: "mask0_1385_3438_00000019656520188517027360000000848818477167143832_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30.3,
    className: "st2",
    width: 85,
    height: 84.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.8,77.3V66.7H83.1v-2.5h10.6V53.7h2.5v10.6h10.6v2.5H96.2v10.6H93.8z M60.7,69.7c-2.6,0-4.9-0.9-6.8-2.8 c-1.9-1.9-2.8-4.1-2.8-6.7s0.9-4.9,2.8-6.7c1.9-1.9,4.1-2.8,6.8-2.8s4.9,0.9,6.8,2.8c1.9,1.9,2.8,4.1,2.8,6.7s-0.9,4.9-2.8,6.7 C65.6,68.8,63.4,69.7,60.7,69.7z M37,94.4v-4.6c0-1.3,0.4-2.5,1.2-3.7c0.8-1.1,1.9-2,3.2-2.7c3.2-1.5,6.5-2.7,9.7-3.4 c3.2-0.8,6.4-1.1,9.6-1.1s6.4,0.4,9.6,1.1c3.2,0.8,6.4,1.9,9.7,3.4c1.4,0.6,2.4,1.5,3.2,2.7c0.8,1.1,1.2,2.4,1.2,3.7v4.6H37z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/createAccount.05c26625f5d821acfd09f7b0012ef970.svg";
export { ForwardRef as ReactComponent };